import styled, { css } from "styled-components";
import TableHead from "@mui/material/TableHead";
import { theme } from "styles/mui-config";
import { Box } from "@mui/system";
import { Typography, Toolbar, TableRow, TableCell } from "@mui/material";

/////////////////////////////////////////////////
export const StyledTableHead = styled(TableHead)`
  background-color: ${theme.palette.primary.dark};
`;

///////////////// Table-toolbar //////////////////-
export const SpeedDialWrapper = styled.div`
  position: absolute;
  left: 15px;
  top: 5px;
`;

////////////////////////////////////////////////
export const ToolbarBox = styled(Box)`
  flex: 1 1 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // min-width: 100px;
  & h6 {
    @media (max-width: 600px) {
      font-size: 17px;
    }
  }
  & h6 {
    @media (max-width: 300px) {
      font-size: 14px;
    }
  }
`;
////////////////////////////////////////////////
export const StyledDateTypo = styled(Typography)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
`;

////////////////////////////////////////////////
export const StyledPhoneTypo = styled(Typography)`
  display: flex;
  align-items: center;
  font-size: 16px;
  justify-content: flex-end;
`;

////////////////////////////////////////////////
const isSeletedRow = ({ $numSelected }) => {
  if ($numSelected)
    return css`
      background-color: ${theme.palette.primary.light};
    `;
};
export const StyledTableToobar = styled(Toolbar)`
  position: relative;
  ${theme.breakpoints.down("md")} {
    padding-left: ${theme.spacing(2)} !important;
    padding-right: ${theme.spacing(1)} !important;
  }
  ${isSeletedRow};
  overflow-x: auto;
  & a > button{
    @media (max-width: 600px) {
      font-size: 12px !important;
    }
  }
  & a > button > span > svg{
    @media (max-width: 600px) {
      font-size: 12px !important;
    }
  }
`;

///////////////// Table-footer /////////////////////
export const StyledTableFooterWrapper = styled(TableRow)`
  border-top: 2px solid ${theme.palette.secondary.dark};
`;
export const StyledFooterCell = styled(TableCell)`
  font-size: 18px !important;
  font-weight: 1000 !important;
  &:nth-child(2) {
    padding: 16px;
    padding-top: 24px;
  }
`;
